// extracted by mini-css-extract-plugin
export default {"btn_wrap":"style_btn_wrap__obSwa","menu_trigger":"style_menu_trigger__MADg+","active":"style_active__tivVR"};